import backendService from './backend-service';
import produce from 'immer';
import { Voucher, VoucherCode } from 'utils/Voucher';

export const parseApiVoucher = (apiVoucher: unknown): Voucher => {
  const v = apiVoucher as {
    code: VoucherCode
    discountType: string;
    discountValue: string | number;
    isValid: string | boolean;
  };

  return {
    code: v.code,
    discountType: (() => {
      if (v.discountType.toLowerCase() === 'fixed') return 'Fixed';
      if (v.discountType.toLowerCase() === 'percentage') return 'Percentage';
      throw Error(`${v.discountType} is not a recognized discount type`);
    })(),
    discountValue: typeof v.discountValue === 'number' ? v.discountValue : Number.parseFloat(v.discountValue),
    isValid: typeof v.isValid === 'boolean' ? v.isValid : v.isValid === 'true',
  };
};

export const voucherToApiBody = (voucher: Voucher) => {
  return {
    ...voucher,
    isValid: voucher.isValid ? 'true' : 'false',
  };
};

export const voucherRequests = {
  get: (code: VoucherCode) => (backendService
    .get(`/voucher/${code}`)
    .then(res => res.data)
    .then(parseApiVoucher)
  ),
  getAll: () => (backendService
    .get('/vouchers')
    .then(res => res.data)
    .then(vouchers => (vouchers as unknown[]).map(parseApiVoucher))
  ),
  getAllByValidity: (valid: boolean) => (backendService
    .get(`/vouchers?isValid=${valid}`)
    .then(res => res.data)
    .then(vouchers => (vouchers as unknown[]).map(parseApiVoucher))
  ),
  post: (newVoucher: Voucher) => backendService.post('/voucher', voucherToApiBody(newVoucher)),
  put: async (updatedVoucher: Voucher, originalCode: string) => {
    const res = await backendService.put('/voucher', voucherToApiBody(updatedVoucher));
    if (updatedVoucher.code !== originalCode) {
      await backendService.delete(`/voucher/${originalCode}`);
    }
    return parseApiVoucher(res.data);
  },
  delete: (code: string) => backendService.delete(`/voucher/${code}`),
  setValidity: (voucher: Voucher, validity: boolean) => {
    const updatedVoucher: Voucher = produce(voucher,
      draft => { draft.isValid = validity; });
    return backendService.put('/voucher', voucherToApiBody(updatedVoucher));
  },
};
